// 1-Eastern, 3-Pacific, 5-Central, 7-Mountain
export type StandardFourTimeZoneId = 1 | 3 | 5 | 7;

export type WeekdayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const DAY_INDICES: WeekdayIndex[] = [0, 1, 2, 3, 4, 5, 6];

export interface BlockoutSlots {
	dayIndex: WeekdayIndex,
	startTimeIndex: number,
	applicantSelectedAccSlot: boolean,
};

export interface SelectedSlots {
	mon: string,
	tue: string,
	wed: string,
	thu: string,
	fri: string,
	sat: string,
	sun: string,
};

export interface SelectedSlotsWithCount extends SelectedSlots {
	numMeetings: number,
}

export const SLOTS_DAY_MAP: Record<WeekdayIndex, keyof SelectedSlots> = {
	0: 'mon',
	1: 'tue',
	2: 'wed',
	3: 'thu',
	4: 'fri',
	5: 'sat',
	6: 'sun'
};

export interface Meetings {
	meetingsId: number,
	selectedMeetingSlots: SelectedSlots,
	numMeetings: number,
	updatedUTC: number,
}